export default __webpack_public_path__ + "static/media/kh.c518b9c1.svg";